<div class="container">
    <div class="contact-us">
        <h2>Contact Us</h2>
        <div class="contact-details">
            <p>
                <strong class="mr-2"><i class="fas fa-map-marker-alt" style="color: #FF5733;"></i> Address:</strong>
                <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
                    <span itemprop="streetAddress">70 Shenton Wy, #15 02</span>,&nbsp;
                    <span itemprop="addressLocality">Singapore</span> &nbsp;
                    <span itemprop="postalCode">079118</span>
                </span>
            </p>
            <p>
                <strong class="mr-2"><i class="fas fa-phone" style="color: #33C1FF;"></i> Phone:</strong>
                <a href="tel:+6581207644" itemprop="telephone">+65 8120 7644</a>
            </p>
        </div>
    </div>
</div>